import script from "./CompanyProductsPdf.vue?vue&type=script&lang=js"
export * from "./CompanyProductsPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__